// extracted by mini-css-extract-plugin
export default {"label":"Label_label__Iueg9","required":"Label_required__VtE-c","labelSmall":"Label_labelSmall__7bFEV","labelLarge":"Label_labelLarge__EZug3"};